var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app', [_c('the-navigation-base'), _c('v-main', [_c('v-app-bar', {
    attrs: {
      "app": "",
      "flat": "",
      "color": _vm.$vuetify.theme.dark ? _vm.backgroundDarkColor : _vm.backgroundColor
    }
  }, [_c('v-app-bar-nav-icon', {
    attrs: {
      "data-test-hamburger": "",
      "color": _vm.$vuetify.theme.dark ? 'white' : 'grey darken-4'
    },
    on: {
      "click": _vm.toggleDrawer
    }
  }), _c('v-spacer'), _c('v-toolbar-title', [_c('v-img', {
    staticStyle: {
      "max-height": "40px"
    },
    attrs: {
      "src": _vm.tryHeaderLogo,
      "contain": ""
    }
  })], 1), _vm.isAuthenticated ? [_c('v-spacer', {
    staticClass: "ml-2"
  }), _c('profile-menu', {
    attrs: {
      "isEndUser": _vm.isEndUser
    }
  })] : _vm.showLoginButton ? [_c('v-spacer'), !_vm.isAuthenticated ? _c('v-btn', {
    attrs: {
      "color": _vm.color,
      "icon": ""
    },
    on: {
      "click": _vm.goToLogin
    }
  }, [_c('v-icon', [_vm._v("mdi-account")])], 1) : _vm._e()] : [_c('v-spacer', {
    staticClass: "ml-12"
  })], _vm.progress ? _c('v-progress-linear', {
    attrs: {
      "value": _vm.progress,
      "absolute": "",
      "bottom": "",
      "color": _vm.color
    }
  }) : _vm._e()], 2), _vm.displayDivider ? _c('v-divider') : _vm._e(), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_vm._t("default")], 2), _vm.partner && _vm.showFooter ? _c('PartnerFooter', {
    staticClass: "d-none d-md-flex",
    attrs: {
      "partnerProp": _vm.partner,
      "color": _vm.color
    }
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }